export interface AccountShare {
  shareId: number;
  sharedWithUserId: number;
  sharedWithUserName: string;
  permission: 'read' | 'write';
  showSentFolder?: boolean | null;
  showMySentFolder?: boolean | null;
  showInAccountsSidebar?: boolean | null;
  createdAt?: string;
}

export function accountSharesSwrKey(accountId: number): string {
  return `/emails/accounts/${accountId}/shares`;
}
